// import { AmericanExpress, UnionPay, Visa } from '@castlery/fortress/Icons';

export const brandIconsMaps = new Map([
  // ['american-express', <AmericanExpress />],
  // ['unionpay', <UnionPay />],
  // ['visa', <Visa sx={{ fontSize: 24 }} />],
  // ['diners-club', <DinersClub />],
  // ['discover', <Discover />],
  // ['jcb', <Jcb />],
  // ['mastercard', <MasterCard />],
]);
